// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__gCTQ0","icon":"holding-image_icon__ZKY6W"};